import { Routes, Route, Navigate } from 'react-router-dom';
import { ErrorBoundary } from './components/ErrorBoundary';
import { ChatPage } from './components/ChatPage';
import { DashboardPage } from './components/Dashboard';
import { ManagementPage } from './components/Management';

/**
 * Demo App - No authentication required
 *
 * This is the public demo version of the Compass RAG system.
 * All routes are accessible without sign-in.
 */
function App() {
  return (
    <ErrorBoundary>
      <Routes>
        <Route path="/" element={<ChatPage />} />
        <Route path="/chats/:chatId" element={<ChatPage />} />
        <Route
          path="/dashboard"
          element={<Navigate to="/dashboard/metrics" replace />}
        />
        <Route path="/dashboard/:tab" element={<DashboardPage />} />
        <Route
          path="/management"
          element={<Navigate to="/management/clients" replace />}
        />
        <Route path="/management/:tab" element={<ManagementPage />} />
        <Route
          path="/management/documents/:clientSlug"
          element={<ManagementPage />}
        />
      </Routes>
    </ErrorBoundary>
  );
}

export default App;
